class ApplicationSeafarerDocument {
    id = 0;
    application_id = null;
    document_type_id = null;
    document_expiration_type_id = null;
    issuing_country_id = null;
    issued_by = '';
    document_number = '';
    date_issued = null;
    date_of_expiry = null;
    uploaded_file = {
        name: '',
        link: '',
        original_name: '',
        upload_id: null,
    };
    archive = false;
    from_archive = false;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default ApplicationSeafarerDocument;
